import {appEnv, INetworkConfig} from "../env";

export const EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000';
export const GOLDEN_PRICE = 0.05;

export const MYTH_PASS_GOLDEN_TOTAL_NUM = 1000;
export const MYTH_PASS_CLASSIC_TOTAL_NUM = 10000;

export function getNFTImage(imageDir:string,nftTypeId:number) {
    return appEnv.mythImageUrl + imageDir + "/" + nftTypeId + ".png";
}

export enum MythPassRarity {
    CLASSIC = 1, GOLDEN
}

export enum LicensingType {
    GENERAL, EXCLUSIVE
}

export enum LicensingRegion {
    REGION
}

export function getOpenseaLink(networkConfig:INetworkConfig,collectionName: string) {
    return networkConfig.marketPlace.mythCollectionPrefix + collectionName;
}

export function getEtherscanLink(networkConfig:INetworkConfig,contractAddr: string) {
    return networkConfig.blockExplorer + "/address/" + contractAddr;
}

export function getNftOpenseaLink(networkConfig:INetworkConfig,contractAddr: string,tokenId:string) {
    return networkConfig.marketPlace.nftUrl + "/" + contractAddr + "/" + tokenId;
}

export const isEmpty = (value: any) => {
    switch (typeof value) {
        case 'undefined':
            return true;
        case 'string':
            if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length === 0) return true;
            break;
        case 'boolean':
            if (!value) return true;
            break;
        case 'number':
            if (0 === value || isNaN(value)) return true;
            break;
        case 'object':
            if (null === value || value.length === 0) return true;
            for (var i in value) {
                return false;
            }
            return true;
    }
    return false;
}


export enum MythServerResultCode{
    SUCCESS= 10000
}

export enum LicensedNFTStatus{
    UNLICENSED =0,
    UNISSUED=1,
    PENDING=2,
    ISSUED=3,
    REJECT=4,
    OVERDUE=5
}

export enum Opration {
    ISSUE=0,
    EDIT=1,
    PULL_OF_SHELF=2,
    RE_PUT_ON_SHELF=3
}

export enum DerivativeWorkStatus{
    UNISSUED,ISSUED
}
